import React from 'react';
import {
  Divider,
  useTheme,
  InputAdornment,
  IconButton,
  makeStyles,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  DatePicker as MaterialDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { FaCalendarAlt, FaTimesCircle } from 'react-icons/fa';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface IDatePcikerProps {
  id: string;
  startDate: Date | null;
  endDate: Date | null;
  onChangeStartDate: any;
  onChangeEndDate: any;
  onClickClearDate: any;
  width?: number | string;
  height?: number | string;
  marginBottom?: number;
  marginTop?: number;
  fontSize?: number;
  iconsSize?: number;
}

const DatePicker: React.FC<IDatePcikerProps> = ({
  id,
  startDate,
  endDate,
  onChangeStartDate,
  onChangeEndDate,
  onClickClearDate,
  width,
  height,
  marginBottom,
  marginTop,
  fontSize,
  iconsSize,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();

  const userStyle = makeStyles({
    customTextField: {
      '& input': {
        textAlign: 'center',
        fontSize,
        fontWeight: 'bold',
      },
      '& input::placeholder': {
        color: '#000000',
        fontWeight: 500,
        fontSize,
        textAlign: 'center',
      },
    },
  });

  const custom = userStyle();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div
        className={classes.container}
        style={{ width, marginBottom, marginTop }}
      >
        <div
          className={classes.startDateContainer}
          style={{
            height,
          }}
        >
          <MaterialDatePicker
            id={`start-picker-${id}-${new Date().getTime()}`}
            autoOk
            disableToolbar
            disableFuture
            maxDate={endDate}
            variant="inline"
            format="dd/MM/yy"
            margin="none"
            placeholder={t('components:selectors.startDate')}
            value={startDate}
            onChange={onChangeStartDate}
            className={clsx(classes.datePicker, {
              [custom.customTextField]: fontSize,
            })}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <FaCalendarAlt
                    size={iconsSize || 16}
                    color={
                      startDate || endDate
                        ? theme.palette.primary.main
                        : theme.palette.text.hint
                    }
                  />
                </InputAdornment>
              ),
            }}
            color="primary"
          />
        </div>

        <Divider flexItem orientation="vertical" />
        <div className={classes.endDateContainer}>
          <MaterialDatePicker
            id={`end-picker-${id}-${new Date().getTime()}`}
            autoOk
            disableToolbar
            disableFuture
            disabled={!startDate}
            minDate={startDate}
            variant="inline"
            format="dd/MM/yy"
            margin="none"
            placeholder={t('components:selectors.endDate')}
            value={endDate}
            onChange={onChangeEndDate}
            className={clsx(classes.datePicker, {
              [custom.customTextField]: fontSize,
            })}
            style={{
              fontSize,
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
          <IconButton
            disabled={!startDate && !endDate}
            onClick={onClickClearDate}
            style={{
              height: 14,
            }}
          >
            <FaTimesCircle
              size={iconsSize || 16}
              color={
                startDate || endDate
                  ? theme.palette.primary.main
                  : theme.palette.text.hint
              }
            />
          </IconButton>
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
